import 'lite-youtube-embed'
import 'lite-vimeo-embed/module/lite-vimeo-embed'

import 'virtual:svg-icons-register'
import.meta.glob('../img/**/*')

import Alpine from 'alpinejs'
import dialog from '@alpinejs/ui/src/dialog'
import disclosure from '@alpinejs/ui/src/disclosure'
import focus from '@alpinejs/focus'

import LocationMap from './alpine-components/LocationMap.js'
import CountdownTimer from './alpine-components/CountdownTimer.js'

import { createTrackingStore } from './stores/trackingStore.js'

import InteractionTracking  from './modules/InteractionTracking.js'
import FormieAutocomplete from './modules/FormieAutocomplete.js'
import EventBus from './modules/EventBus.js'
import Queue from './modules/Queue.js'
import FormieTracking from './modules/FormieTracking.js'

Alpine.data('countdownTimer', CountdownTimer)
Alpine.data('locationMap', LocationMap)

export function init() {

  const APP = window.APP || {
    CONFIG: {},
    queue: [],
  }

  const eventBus = new EventBus()

  // Make Alpine available globally for debugging
  window.Alpine = Alpine

  Alpine.plugin(dialog)
  Alpine.plugin(disclosure)
  Alpine.plugin(focus)

  Alpine.store('headerModal', {
    open: false,

    show() {
      this.open = true
    },

    hide() {
      this.open = false
    },
  })

  const trackingStore = createTrackingStore(APP.CONFIG?.siteHandle || 'default')
  trackingStore.init()
  Alpine.store('tracking', trackingStore)


  window.APP = {
    ...APP,
    Alpine,
    eventBus,
    queue: new Queue(eventBus, APP.queue, APP.CONFIG),
    stores: {
      trackingStore,
    },
    modules: {
      FormieAutocomplete: FormieAutocomplete(),
      FormieTracking: new FormieTracking(trackingStore, APP.CONFIG, eventBus),
      InteractionTracking: InteractionTracking(trackingStore, APP.CONFIG),
    },

    trigger: (eventName, data)  => eventBus.emit(eventName, data),
  }

  Alpine.start()
}

// Initialize immediately if DOM is already loaded, otherwise wait
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => init())
} else {
  init()
}

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('HMR')
  })
}
